import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddComponent } from './add/add.component';
import { ListComponent } from './list/list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { ViewComponent } from './view/view.component';
import { ContactRoutingModule } from './contact-routing.module';
import { NgxMaskModule } from 'ngx-mask';
import { QuillModule } from 'ngx-quill';
import { GuestContactListComponent } from './guest-contact-list/guest-contact-list.component';
import { MatMenuModule } from '@angular/material/menu';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    AddComponent,
    ListComponent,
    ViewComponent,
    GuestContactListComponent
  ],
  imports: [
    CommonModule,
    ContactRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    SwiperModule,
    PipeModule,
    NgxDatatableModule,  
    NgxMaskModule.forRoot(),
    QuillModule.forRoot(),
    MatMenuModule,
    NgxSpinnerModule

  ]
})
export class ContactModule { }
